// extracted by mini-css-extract-plugin
export default {"category":"AiSuggestions_category__vvAne","title":"AiSuggestions_title__5jL7Y","results":"AiSuggestions_results__Wz4Nh","header":"AiSuggestions_header__VST-S"};